import { Injectable } from '@angular/core';
import { ApiService } from '@app/api/api.service';
import {
  ConfirmResponse,
  OrderDto,
  OrderPointDto,
  OrderPointRequest,
  OrderRequest,
  ShareOrderRequest,
  UnshareOrderRequest,
} from '@app/models';
import { Observable } from 'rxjs';
import { OrderShareDto } from './../models/order.model';

const prefix = '/order';
const pointPrefix = `${prefix}/point`;

@Injectable({ providedIn: 'root' })
export class OrderApi extends ApiService {
  public getOrders$(
    routeDetails: boolean,
    noCache: boolean,
  ): Observable<OrderDto[]> {
    return this.get<OrderDto[]>(
      `${prefix}/list?route_details=${routeDetails}`,
      true,
      {
        headers: noCache
          ? {
              'Cache-Control': 'no-cache',
            }
          : {},
      },
    );
  }

  public getOrdersNoCache$(routeDetails: boolean): Observable<OrderDto[]> {
    return this.get<OrderDto[]>(
      `${prefix}/list/noCache?route_details=${routeDetails}`,
      true,
    );
  }

  public addOrder$(body: OrderRequest): Observable<OrderDto> {
    return this.post<OrderRequest, OrderDto>(`${prefix}`, body);
  }

  public updateOrder$(
    orderId: number,
    body: OrderRequest,
  ): Observable<OrderDto> {
    return this.put<OrderRequest, OrderDto>(`${prefix}/${orderId}`, body);
  }

  public removeOrder$(orderId: number): Observable<ConfirmResponse> {
    return this.delete<ConfirmResponse>(`${prefix}/${orderId}`);
  }

  public getOrderPoints$(orderId: number): Observable<OrderPointDto[]> {
    return this.get<OrderPointDto[]>(`${pointPrefix}/${orderId}/list`, true);
  }

  public addOrderPoint$(
    orderId: number,
    body: OrderPointRequest,
  ): Observable<OrderPointDto> {
    return this.post<OrderPointRequest, OrderPointDto>(
      `${pointPrefix}/${orderId}`,
      body,
    );
  }

  public updateOrderPoint$(
    orderId: number,
    pointId: number,
    body: OrderPointRequest,
  ): Observable<OrderPointDto> {
    return this.put<OrderPointRequest, OrderPointDto>(
      `${pointPrefix}/${orderId}/${pointId}`,
      body,
    );
  }

  public startOrder(orderId: number): Observable<OrderDto> {
    return this.post<{}, OrderDto>(`${prefix}/start/${orderId}`);
  }

  public cancelOrder(orderId: number): Observable<OrderDto> {
    return this.post<{}, OrderDto>(`${prefix}/finish/${orderId}`);
  }

  public getSharedOrders$(noCache?: boolean): Observable<OrderShareDto[]> {
    return this.get<OrderShareDto[]>(`${prefix}/shared/list`, false, {
      headers: noCache
        ? {
            'Cache-Control': 'no-cache',
          }
        : {},
    });
  }

  public shareOrder$(order: ShareOrderRequest): Observable<OrderShareDto> {
    return this.post<any, OrderShareDto>(
      `${prefix}/share/${order.orderId}`,
      order,
    );
  }

  public unShareOrder$(
    share: UnshareOrderRequest,
  ): Observable<ConfirmResponse> {
    return this.delete<ConfirmResponse>(
      `${prefix}/share/${share.orderId}/${share.id}`,
    );
  }
}
